import React from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { useTrans } from 'base/utils/i18n';

type CheckoutStepsProps = {
    current: number;
};

const steps = ['web_checkout_step_my_cart', 'web_checkout_step_place_order', 'web_checkout_step_pay', 'web_checkout_step_order_complete'];

const CheckoutSteps: React.FC<CheckoutStepsProps> = ({ current }) => {
    const { t } = useTrans();
    return (
        <div className="wrapper">
            <div className={styles.steps}>
                {steps.map((item, index) => (
                    <React.Fragment key={index}>
                        {index !== 0 && <em>&gt;</em>}
                        <span
                            className={cn({
                                [styles.active]: current === index + 1
                            })}
                        >
                        {t(item)}
                    </span>
                    </React.Fragment>
                ))}
            </div>
        </div>
    )
};

export default CheckoutSteps;